import React from 'react';

import HashNavigation from '../lib/navigation.js';

const PASSENGER_TEMPLATES = [
    {
        key: 'passenger-greeting-safety-reminder',
        name: 'Passenger Greeting & Safety Reminder.',
        message: (customerName, driverName) => {
            return `Hi ${customerName}! I'm ${driverName}, AngKasama mong Biker for today! I'm on my way right now.

Please check our safety reminders in the app. Thank you for choosing a safe ride with ANGKAS today!`;
        },
    },
    {
        key: 'arrival-at-pickup-location',
        name: 'Arrival at Pickup Location.',
        message: () => {
            return `I've arrived! Thank you for patiently waiting.

Please be at your pickup location within 5 mins to avoid cancellation. TY!`;
        },
    },
    {
        key: 'traffic-message',
        name: 'Traffic Message.',
        message: () => {
            return `I'm taking longer than usual due to traffic, but I'll be there in a few minutes. Please wait for me.`;
        },
    },
];

const PADALA_TEMPLATES = [
    {
        key: 'sender-greeting',
        name: 'Sender Greeting.',
        message: (customerName, driverName) => {
            return `Hi ${customerName}! I'm ${driverName}, AngKasama mo sa pagpapadala! I'm on my way to pick up your package.

Please ensure your item is secured and ready.`;
        },
    },
    {
        key: 'receiver-greeting',
        name: 'Receiver Greeting.',
        message: (customerName, driverName) => {
            return `Hi ${customerName}! I'm ${driverName}, AngKasama mo sa pagpapadala! I'm on my way to deliver your package.

Please ensure someone is available to receive at drop-off.`;
        },
    },
    {
        key: 'traffic-message',
        name: 'Traffic Message.',
        message: () => {
            return `I'm taking longer than usual due to traffic, but I'll be there in a few minutes. Please wait for me.`;
        },
    },
];

const ANGCARS_TEMPLATES = [
    {
        key: 'passenger-greeting-safety-reminder',
        name: 'Passenger Greeting & Safety Reminder.',
        message: (customerName, driverName) => {
            return `Hi ${customerName}! I'm ${driverName}, your AngCars Driver for today! I'm on my way right now.

Please check our safety reminders in the app. Thank you for choosing a safe ride with ANGCARS today!`;
        },
    },
    {
        key: 'arrival-at-pickup-location',
        name: 'Arrival at Pickup Location.',
        message: () => {
            return `I've arrived! Thank you for patiently waiting.

Please be at your pickup location within 5 mins to avoid cancellation. TY!`;
        },
    },
    {
        key: 'traffic-message',
        name: 'Traffic Message.',
        message: () => {
            return `I'm taking longer than usual due to traffic, but I'll be there in a few minutes. Please wait for me.`;
        },
    },
];

function getTemplatesForServiceType(serviceTypeId) {
    switch (serviceTypeId) {
        case 'passenger_bike':
            return PASSENGER_TEMPLATES;
        case 'padala_bike':
            return PADALA_TEMPLATES;
        case 'passenger_four_seater':
        case 'passenger_six_seater':
            return ANGCARS_TEMPLATES;
        default:
            return PASSENGER_TEMPLATES;
    }
}

// The host may pass serviceTypeId as a query param (?serviceTypeId=) or inside the
// hash route (#/dax/<topic>?serviceTypeId=). Captured at module load, before auth
// and hash navigation rewrite the URL.
function readServiceTypeId() {
    const fromQuery = new URLSearchParams(globalThis.location.search).get('serviceTypeId');
    if (fromQuery) {
        return fromQuery;
    }
    return HashNavigation.parseUrlHash(globalThis.location.hash).params.serviceTypeId || null;
}

const SERVICE_TYPE_ID = readServiceTypeId();

export default class MessageTemplate extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleTemplateClick = this.handleTemplateClick.bind(this);
    }

    handleTemplateClick(template) {
        const topic = this.props.tinode.getTopic(this.props.topicName);

        if (topic) {
            const userKeys = Object.keys(topic._users);

            const fullNames = userKeys.reduce((acc, userID) => {
                const userData = topic._users[userID];
                if (!userData.public.type) {
                    return acc;
                }

                const fullName = userData.public.fn;

                return [...acc, {
                    type: userData.public.type,
                    fullName: fullName ?? '',
                }];
            }, []);

            const customerName = fullNames.find((name) => name.type === 'cs')?.fullName ?? 'Customer';
            const driverName = fullNames.find((name) => name.type === 'dr')?.fullName ?? 'Driver';

            this.props.setMessage(template.message(customerName, driverName));
        }
    }

    render() {
        const templates = getTemplatesForServiceType(SERVICE_TYPE_ID);

        return <div id="message-template-panel">
            {
                templates.map((template) => {
                    return (
                        <div key={template.key} className="message-template">
                            <button className="message-template-button" onClick={() => this.handleTemplateClick(template)}>
                                {template.name}
                            </button>
                        </div>
                    );
                })
            }
        </div>;
    }
};
